import { UapLocation } from 'src/app/core/models/admin/adl.model';

export const CONSTANTS = {
  HEADER: $localize`Edit Access Points`,
  ASSIGNED_HEADER_TEXT: $localize`Assigned Access Points`,
  AVAILABLE_HEADER_TEXT: $localize`Available Access Point(s)`,
  SAVE: $localize`Save`,
  BACK: $localize`Back`,
};

export type EditAccessInput = {
  data: UapLocation[];
  name: string;
};

export type EditRoutesData = {
  data: UapLocation;
  selected: boolean;
};

export enum MODE {
  ADD,
  EDIT,
}
